import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";

import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";
import { Full_ROUTES } from "./shared/routes/full-layout.routes";
import { DashboardComponent } from './form/dashboard/dashboard.component'; 
const routes: Routes = [
  
  {
    path: '',
    // redirectTo: 'form/dashboard',
    redirectTo: 'auth/signin',
    pathMatch: 'full',
  },
  { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES },
  { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
  // { path: '**', redirectTo: 'form/dashboard' },
  { path: '**', redirectTo: 'auth/signin' },
  // { path: 'dashboard', component: DashboardComponent },  // Add route for dashboard
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
